import React, { useEffect, useRef, useState } from 'react';

const LineLayPricesBox = ({
  runner,
  config,
  value,
  checkMaxOdds,
  validationBM,
  getLock,
  handleOnBackClick,
  checkSuspendedMatchOdds,
  getBoxValue,
}) => {
  const [highlighted, setHighlighted] = useState(['', '', '']);

  const prevPricesRef = useRef([
    { price: null, size: null },
    { price: null, size: null },
    { price: null, size: null },
  ]);
  const firstRender = useRef(true);

  useEffect(() => {
    if (firstRender.current) {
      firstRender.current = false;
      for (let i = 0; i < 3; i++) {
        prevPricesRef.current[i] = {
          price: runner.layPrices?.[i]?.price,
          size: runner.layPrices?.[i]?.size,
        };
      }
      return;
    }

    const newHighlights = ['', '', ''];
    let changed = false;

    for (let i = 0; i < 3; i++) {
      const current = runner.layPrices?.[i];
      const prev = prevPricesRef.current[i];

      if (current?.price !== prev?.price || current?.size !== prev?.size) {
        if (current?.price > prev?.price) {
          newHighlights[i] = 'higilighted';
        } else if (current?.price < prev?.price) {
          newHighlights[i] = 'higilighted';
        }

        prevPricesRef.current[i] = { price: current?.price, size: current?.size };
        changed = true;

        setTimeout(() => {
          setHighlighted((prev) => {
            const updated = [...prev];
            updated[i] = '';
            return updated;
          });
        }, 500);
      }
    }

    if (changed) {
      setHighlighted(newHighlights);
    }
  }, [runner.layPrices]);

  const renderSpan = (index, className) => {
    const lay = runner.layPrices?.[index];
    const disabled = checkMaxOdds(value?.marketId, lay?.price ?? 0);

    return (
      <span
        className={`${className} ${disabled ? '' : 'disable'} ${highlighted[index]}`}
        onClick={() => validationBM(lay?.price) ?
          handleOnBackClick(
            runner,
            config.lay,
            value.marketId,
            lay?.price,
            config.isNotfancy,
            value
          ) :''
        }
      >
        {validationBM(lay?.price) && !checkSuspendedMatchOdds ? getBoxValue(lay) : getLock()}
      </span>
    );
  };

  return (
    <>
      {renderSpan(2, 'pink')}
      {renderSpan(1, 'pink')}
      {renderSpan(0, 'pink')}
    </>
  );
};

export default LineLayPricesBox;